const vehicleReport = {
  title: 'Bericht über Fahrzeugfahrten',
  description: 'Bietet statistische Informationen zur Aktivität einzelner Fahrer.',
  table: {
    headers: {
      id: 'Ausweis',
      driver: 'Fahrer',
      supplier: 'Lieferant',
      vehicle: 'Fahrzeug',
      zones: 'Zonen',
      locations: 'Standorte',
      profiles: 'Profile',
      attributes: 'Attribute',
      driverShifts: 'Schicht',
      trips: 'Fahrten',
      departureTime: 'ABFAHRTSZEIT',
      start: 'Starten',
      end: 'Ende',
      hours: 'Stunden',
      reservations: 'Gesamtbuchungen',
      tripsDuration: 'Trips Duration',
      avgTripsDuration: 'AVG Trips Duration',
      idleTime: 'Idle Time',
      idleTimeRatio: 'Idle Ratio',
      tripsDistance: 'Trips Distance',
      avgTripsDistance: 'AVG Trips Distance',
      deadheadDistance: 'Deadhead Distance',
      deadheadDistanceRatio: 'Deadhead Ratio',
      loadedDistance: 'Strecke mit Fahrgast',
      earningPerHour: 'Verdienst pro Stunde',
      totalEarnings: 'Gesamteinnahmen',
    },
    driver: 'Fahrer',
    Amount: 'Anzahl',
    unassignedTrips: 'Nicht zugewiesen',
    yes: 'JA',
    no: 'NEIN',
  },

  filter: {
    export: 'Exportieren',
    driver: 'Fahrer',
    supplier: 'Lieferant',
    car: 'Fahrzeug',
    zones: 'Zonen',
    locations: 'Standardstandorte',
    airportLocations: 'Flughafenstandorte',
    profiles: 'Profile',
    attributes: 'Attribute',
    submit: 'Filter',
    clear: 'Filter löschen',
    driverShifts: {
      title: 'Fahrerschichten',
      options: {
        withShifts: 'Mit Schicht',
        withoutShifts: 'Ohne Schicht',
      },
    },
    validation: {
      startDateRequired: 'Startdatum ist erforderlich',
      endDateRequired: 'Enddatum ist erforderlich',
    },
  },

  vehicleSummary: {
    total: 'Fahrzeuge',
    totalTrips: 'Fahrten insgesamt',
    totalReservation: 'Gesamtbuchungen',
    assignedTrips: 'Zugewiesene Fahrten',
    notAssignedReservations: 'Nicht zugewiesene Buchungen',
    notAssignedTrips: 'Nicht zugewiesene Fahrten',
    assignedReservations: 'Zugewiesene Buchungen',
    averageTripDistance: 'Durchschnittliche Fahrtstrecke',
    averageTripDeadheadDistance: 'AVG Trip Deadhead Distance',
    averageTripDuration: 'Durchschnittliche Fahrtdauer',
    averageIdleTime: 'Durchschnittliche Leerlaufzeit',
    averageIdleTimeRatio: 'Durchschnittliches Leerlaufverhältnis',
    averageTripsPerDriver: 'Durchschnittliche Fahrten pro Fahrer',
    averageEarningsPerDriver: 'Durchschnittlicher Fahrerlohn',
    loadedDistance: 'Beladene Distanz',
    totalEarnings: 'Gesamteinnahmen',
    averageTripEarnings: 'Durchschnittlicher Fahrterlös',
    totalDrivers: 'Fahrer insgesamt',
    totalVehicles: 'Fahrzeuge insgesamt',
    rideShareTrips: 'Geteilte Fahrten',
    rideShareReservations: 'Geteilte Buchungen',
    driversWithShifts: 'Fahrer mit Schichten',
    earningPerHour: 'Verdienst pro Stunde',
    canceledTrips: 'Canceled Trips',
    canceledReservations: 'Stornierte Buchungen',
    onTimePerformance: 'On Time Performance',
    noShow: 'Nichterscheinen',
    averageDeadhead: 'Durchschnittlicher Leerlauf',
    activeDrivers: 'Active Drivers',
    inrouteTrips: 'En-route Trips'
  },

  form: {
    dateEnd: 'Datum Ende',
    dateStart: 'Datum Beginn',
  },
  export: 'Fahrzeugbericht',
};

export default vehicleReport;
